import React, { Component } from "react";
import { connect } from "react-redux";
import { TextField } from "@mui/material";

class PriceInput extends Component {
    constructor(props) {
        super(props);

        this.lastValidValue =
            props.initialValue != null
                ? String(props.initialValue).replace(".", ",")
                : props.minPrice != null
                    ? props.minPrice.toFixed(2).replace(".", ",")
                    : "0";
    }

    onEndEditing = () => {
        const { value, minPrice, maxPrice, setValue } = this.props;

        if (!value) {
            setValue(this.lastValidValue, true);
            return;
        }

        const numericValue = parseFloat(String(value).replace(",", "."));

        if (isNaN(numericValue)) {
            setValue(this.lastValidValue, true);
            return;
        }

        if (numericValue <= 0) {
            window.alert(
                "Only positive numbers allowed"
            );
            setValue(this.lastValidValue, true);
            return;
        }

        if (minPrice != null && numericValue < minPrice) {
            const fixed = minPrice.toFixed(2).replace(".", ",");
            setValue(fixed, true);
            window.alert(
                `Enter a value between ${minPrice} and ${maxPrice}` ||
                `Enter a value between ${minPrice} and ${maxPrice}`
            );
            return;
        }

        if (maxPrice != null && numericValue > maxPrice) {
            const fixed = maxPrice.toFixed(2).replace(".", ",");
            setValue(fixed, true);
            window.alert(
                `Enter a value between ${minPrice} and ${maxPrice}` ||
                `Enter a value between ${minPrice} and ${maxPrice}`
            );
            return;
        }

        const fixed = numericValue.toFixed(2).replace(".", ",");
        this.lastValidValue = fixed;
        setValue(fixed, true);
    };

    handleFocus = () => {
        this.props.setValue("");
    };

    handleChange = (e) => {
        this.props.setValue(e.target.value);
    };
    handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.target.blur();
        }
    };

    render() {
        const {
            value,
            maxLength,
            setValue,
            initialValue,
            minPrice,
            maxPrice,
            ...textFieldProps
        } = this.props;

        return (
            <TextField
                {...textFieldProps}
                fullWidth={textFieldProps.fullWidth ?? true}
                onKeyDown={this.handleKeyDown}
                value={value != null ? String(value).replace(".", ",") : ""}
                placeholder={textFieldProps.placeholder ?? "Wert"}
                onFocus={this.handleFocus}
                onChange={this.handleChange}
                onBlur={this.onEndEditing}
                inputProps={{
                    maxLength: maxLength ?? 6,
                    inputMode: "decimal",
                    ...textFieldProps.inputProps,
                }}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        height: 40,
                    },
                    // marginTop: "5px",
                    ...textFieldProps.sx,
                }}
            />
        );
    }
}

const mapStateToProps = (state) => ({

});

export default connect(mapStateToProps)(PriceInput);